import { Controller } from "@hotwired/stimulus"

// disclosure — botão que mostra/esconde um painel (seção recolhível). Genérico e
// CSP-safe. O botão dispara disclosure#toggle; o painel é o target "panel"; um
// ícone opcional "chevron" gira 180° quando aberto.
//
//   <div data-controller="disclosure">
//     <button data-action="disclosure#toggle" aria-expanded="false">
//       … <svg data-disclosure-target="chevron"> …
//     </button>
//     <div data-disclosure-target="panel" hidden> … </div>
//   </div>
//
// `data-disclosure-open-value="true"` no root abre por padrão.
//
// LABEL "Ver mais / Ver menos": um alvo "label" com data-more/data-less troca o
// texto conforme o estado (útil pra botão que expande uma lista). Opcional.
export default class extends Controller {
  static targets = ["panel", "chevron", "button", "label"]
  static values  = { open: Boolean }

  connect() {
    this.apply()
  }

  toggle() {
    this.openValue = !this.openValue
    this.apply()
  }

  apply() {
    if (this.hasPanelTarget) this.panelTarget.hidden = !this.openValue
    if (this.hasChevronTarget) {
      this.chevronTarget.style.transform = this.openValue ? "rotate(180deg)" : ""
    }
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", String(this.openValue))
    }
    if (this.hasLabelTarget) {
      const { more, less } = this.labelTarget.dataset
      const next = this.openValue ? less : more
      if (next) this.labelTarget.textContent = next
    }
  }
}
